<template lang="pug">
  v-container(fluid)
    v-row.px-2.px-sm-10.pb-10
      v-col(cols="12")
        h1 {{ translations.title }}

    v-row.px-2.px-sm-10.pb-10(align="center" justify="center")
      //- filtros
      v-col(cols="12" md="4" sm="6")
        v-text-field(v-model="namefilter", :label="translations.filter.name" clearable)
      v-col(cols="12" md="4" sm="6")
        v-select(v-model="sportfilter", :items="sports" item-text="text" item-value="value" return-object :label="translations.filter.sport" clearable)
      v-col(cols="12" md="4" sm="6")
        v-select(v-model="statusfilter", :items="status" item-text="text" item-value="value" return-object :label="translations.filter.status" clearable)

      //- vista como table
      v-col(cols="12")
        v-data-table(
          :headers="headers"
          :items="datos" 
          :items-per-page="30"
          :custom-sort="customSort"
          sort-by="startdate"
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
          )
          template(v-slot:body="{ items }")
            tbody
              tr(v-for="item,ind in items"  :key="'item'+item._id")
                td
                  BaseConfirmDialog(v-if="hasPermission('views.fantasy.matchsets.publicMatchset')" @confirm="togglePublic(item._id)" v-bind="translations.confirmationDialog.public")
                    template(v-slot="{ on }")
                      v-btn(v-on="on", :loading="loadingToggleMatchset" small text fab outlined color="grey darken-2")
                        v-icon(v-if="item.public") mdi-lock-open-variant
                        v-icon(v-else) mdi-lock
                  v-chip(v-else outlined color="grey darken-2")
                    v-icon(v-if="item.public") mdi-lock-open-variant
                    v-icon(v-else) mdi-lock
                td
                  span.fantasy__block-width--8 {{ item.name }}
                td {{ item.sport }}
                td {{ item.status.text }}
                td {{ item.createdBy }}
                td
                  span.fantasy__block-width--8 {{ item.startdate }}
                td
                  span.fantasy__block-width--8 {{ item.enddate }}
                td
                  span(v-if="item.status.value == 'closed'").red--text {{ translations.closed}}
                  v-menu(v-else-if="hasPermission('views.fantasy.matchsets.actionsMatchset')" offset-y)
                    template(v-slot:activator="{ on }")
                      v-btn(:color="getColorStatus(item.status.value)" v-on="on" text)
                        v-icon mdi-cog-outline
                    v-list.fantasy-contest__list
                      v-list-item(v-if="item.status.value === 'new' || item.status.value === 'pending' ")
                        v-list-item-title.text-center
                          BaseConfirmDialog(@confirm="executeMatchsetAction(item._id,'open')" v-bind="translations.confirmationDialog.actions")
                            template(v-slot="{ on }")
                              v-btn(v-on="on" text).green--text {{ translations.actions.open}}
                      v-list-item(v-else-if="item.status.value === 'open'")
                        v-list-item-title.text-center
                          BaseConfirmDialog(@confirm="executeMatchsetAction(item._id,'close')" v-bind="translations.confirmationDialog.actions")
                            template(v-slot="{ on }")
                              v-btn(v-on="on" text).red--text {{ translations.actions.close}}
                  v-chip(v-else :color="getColorStatus(item.status.value)" label)
                    v-icon mdi-cog-outline
                td
                  BaseConfirmDialog(v-if="hasPermission('views.fantasy.matchsets.loadMatchset')" @confirm="executeMatchsetAction(item._id,'load')" v-bind="translations.confirmationDialog.reload")
                    template(v-slot="{ on }")
                      v-btn(v-on="on" :disabled="item.status.value == 'closed' ? false  : true" text).orange--text
                        v-icon mdi-reload
                  v-chip(v-else color="transparent")
                    v-icon mdi-reload
                td
                  MatchsetInfoDialog(@openMatchsetInfoDialog="getDetailMatchsetInfo(item._id)", :buttonText="translations.buttonInfo", :title="`${item.name}, ${item.startdate}, ${item.status.text}`", :info="detailMatchsetInfo", :loading="loadingDetailMatchsetInfo")
                td(v-if="hasPermission('views.fantasy.matchsets.editMatchset')")
                  BaseDialog(v-if="!isClosed(item)", type="edit", :title="translationsForm.title.edit+item.name" v-slot="{close, opened}")
                    MatchsetEdit(@successEdit="updateMatchset(opened,close)", :clearForm="opened", :translations="translationsForm", :matchset="item")
          template(v-slot:footer)
            .d-flex.justify-space-between.flex-wrap.pa-2
              span.mr-2.mb-2
                v-btn.mr-2(:color="getColorStatus('pending')" readonly text)
                    v-icon mdi-cog-outline
                span {{ $t('back.status.pending') }}
              span.mr-2.mb-2
                v-btn.mr-2(:color="getColorStatus('new')" readonly text)
                    v-icon mdi-cog-outline
                span {{ $t('back.status.new') }}
              span.mr-2.mb-2
                v-btn.mr-2(:color="getColorStatus('open')"  readonly text)
                  v-icon mdi-cog-outline
                span {{ $t('back.status.open') }}
              span.mr-2.mb-2
                v-btn.mr-2(:color="getColorStatus('closed')" readonly text)
                  v-icon mdi-cog-outline
                span {{ $t('back.status.closed') }}
              span.mr-2.mb-2
                v-btn.mr-2(:color="getColorStatus('finished')" readonly text)
                  v-icon mdi-cog-outline
                span {{ $t('back.status.finished') }}
      BaseDialog(v-if="hasPermission('views.fantasy.matchsets.createMatchset')" type="create", :title="translationsForm.title.create" v-slot="{close, opened}")
        MatchsetCreate(@successCreate="updateMatchset(opened,close)", :clearForm="opened", :translations="translationsForm")
</template>

<script>

  import { sports } from "@/store/variablesGlobals";
  import MatchsetInfoDialog from "@/components/dialogs/info/MatchsetInfoDialog";
  import MatchsetCreate from '@/components/forms/MatchsetCreate';
  import MatchsetEdit from '@/components/forms/MatchsetEdit';

  export default {
    name: 'FantasyMatchsetsIndex',
    components: {
      MatchsetInfoDialog,
      MatchsetCreate,
      MatchsetEdit,
    },
    data: () => ({
      namefilter: '',
      sportfilter: {
        text: '',
        value: ''
      },
      statusfilter: {
        text: '',
        value: ''
      },
    }),
    computed: {
      translations() {
        return this.$t("views.matchsetsIndex");
      },
      translationsForm() {
        return this.$t("forms.matchsets");
      },
      headers(){
        let headers = [
          {
            text: this.translations.tableHeadText.public,
            value: 'public'
          },
          {
            text: this.translations.tableHeadText.name,
            value: 'name'
          },
          {
            text: this.translations.tableHeadText.sport,
            value: 'sport'
          },
          {
            text: this.translations.tableHeadText.status,
            value: 'status'
          },
          {
            text: this.translations.tableHeadText.createdBy,
            value: 'createdBy'
          },
          {
            text: this.translations.tableHeadText.startdate,
            value: 'startdate'
          },
          {
            text: this.translations.tableHeadText.enddate,
            value: 'enddate'
          },
          {
            text: this.translations.tableHeadText.options,
            value: 'options',
            sortable: false
          },
          {
            text: this.translations.tableHeadText.load,
            value: 'load',
            sortable: false
          },
          {
            text: '',
            value: 'stats',
            sortable: false
          },
        ];
        if(this.hasPermission('views.fantasy.matchsets.editMatchset')){
          headers.push(
            {
              text: '',
              value: 'edit',
              sortable: false
            });
        }
        return headers;
      },
      datos(){
        const vm = this;
        return this.matchsetsFiltered.map(matchset =>{
          return {
            _id: matchset._id,
            name: matchset.name,
            sport: matchset.sport == '' || matchset.sport == undefined ? '' : vm.$t('back.sport.'+ matchset.sport),
            status: {
              text: matchset.status != ''? vm.$t('back.status.'+ matchset.status) : '',
              value: matchset.status
            },
            createdBy: matchset.creator,
            startdate: vm.$moment(matchset.start).format('DD/MM/YYYY HH:mm'),
            enddate: vm.$moment(matchset.end).format('DD/MM/YYYY HH:mm'),
            public: matchset.public || false,
          }
        })
      },
      sports(){
        return sports(this.$i18n.locale);
      },
      status(){
        return [
          {
            text: this.$t('back.status.new'),
            value: 'new'
          },
          {
            text: this.$t('back.status.open'),
            value: 'open'
          },
          {
            text: this.$t('back.status.closed'),
            value: 'closed'
          },
          {
            text: this.$t('back.status.finished'),
            value: 'finished'
          }
        ];
      },
      matchsetsListAll() {
        return this.$store.state.fantasy.matchsets;
      },
      matchsetsFiltered(){
        const vm = this;

        const filters = {
          name: {
            function: vm.filterName,
            condition: vm.namefilter
          },
          sport: {
            function: vm.filterSport,
            condition: vm.sportfilter
          },
          status: {
            function: vm.filterStatus,
            condition: vm.statusfilter
          }

        };

        return this.matchsetsListAll.filter(matchset => {
          const filterKeys = Object.keys(filters);
          return filterKeys.every(key => {
            return filters[key]['function'](matchset, filters[key]['condition']);
          });
        });
      },
      loadingToggleMatchset(){
        return this.$store.state.statusCode.toggleMatchset.loading;
      },
      statusToggleMatchset(){
        return this.$store.state.statusCode.toggleMatchset.state;
      },
      detailMatchsetInfo(){
        return this.$store.state.fantasy.detailMatchset;
      },
      loadingDetailMatchsetInfo(){
        return this.$store.state.statusCode.detailMatchset.loading;
      },
    },
    watch: {
      statusToggleMatchset: function(val){
        if (val == 200){
          this.getMatchsets();
        }
      },
    },
    created(){
      this.$store.dispatch('getMatchsets');
    },
    methods:{
      dateFormat(dateString){
        const date = new Date(dateString);
        return date.getFullYear() + '-' + date.getMonth() +'-'+ date.getDate();
      },
      filterSport(item, condition){
        return condition == undefined || condition.value == '' || item.sport == condition.value;
      },
      filterStatus(item, condition){
        return condition == undefined || condition.value == '' || item.status == condition.value;
      },
      filterName(item, condition){
        return condition == undefined || condition == '' || item.name.toLowerCase().indexOf(condition.toLowerCase()) != -1;
      },
      executeMatchsetAction(matchsetId,type){
        this.$store.dispatch('actionMatchset',{ matchsetId:matchsetId, type:type });
      },
      customSort(list, index, isDesc){
        list.sort((a, b) => {
          if (index[0]=='startdate') {
            if (!isDesc[0]) {
              return new Date(b[index]).getTime() - new Date(a[index]).getTime();
            } else {
              return new Date(a[index]).getTime() - new Date(b[index]).getTime();
            }
          } else if (index[0]=='enddate') {
            if (!isDesc[0]) {
              return new Date(b[index]).getTime() - new Date(a[index]).getTime();
            } else {
              return new Date(a[index]).getTime() - new Date(b[index]).getTime();
            }
          } else if (index[0]=='public') {
            if (!isDesc[0]) {
              return a[index].toString().toLowerCase().localeCompare(b[index].toString().toLowerCase());
            } else {
              return b[index].toString().toLowerCase().localeCompare(a[index].toString().toLowerCase());
            }
          } else if (index[0]=='status') {
            if (!isDesc[0]) {
              return a[index].text.toString().toLowerCase().localeCompare(b[index].text.toString().toLowerCase());
            } else {
              return b[index].text.toString().toLowerCase().localeCompare(a[index].text.toString().toLowerCase());
            }
          } else if (typeof a[index] !== 'undefined'){ //Para el resto
            if (!isDesc[0]) {
              return a[index].toLowerCase().localeCompare(b[index].toLowerCase());
            }
            else {
              return b[index].toLowerCase().localeCompare(a[index].toLowerCase());
            }
          }
        });
        return list;
      },
      togglePublic(competitionid){
        this.$store.dispatch('toggleMatchset', competitionid);
      },
      getMatchsets(){
        this.$store.dispatch('getMatchsets');
      },
      updateMatchset(opened, closedialog){
        if(opened) {
          if(closedialog != undefined){
            closedialog();
          }
          this.$store.dispatch('getMatchsets');
        }
      },
      getColorStatus(val){
        if (val == 'open'){
          return 'green  lighten-4';
        } else if (val == 'new'){
          return 'blue lighten-4';
        } else if (val == 'closed'){
          return 'red lighten-4';
        } else if (val == 'pending'){
          return 'brown lighten-4';
        } else if (val == 'finished'){
          return 'blue-grey lighten-4';
        }
      },
      getDetailMatchsetInfo(matchsetId){
        this.$store.dispatch('getDetailMatchset',matchsetId);
      },
      isClosed(item){
        return item.status.value == 'closed';
      },
    }
  }
</script>

<style lang="sass">
.fantasy-contest__list
  .v-list-item + .v-list-item
    border-top: 1px solid rgba(0, 0, 0, 0.12)
</style>